/* NanaCare redesign – shared behaviour (vanilla JS, from the approved mock-ups). */
(function () {
  if (window.NanaRedesign) return;
  const NR = (window.NanaRedesign = {});

  /* ---------- reveal-on-scroll + count-ups ---------- */
  function countUp(el) {
    const to = +el.dataset.count, t0 = performance.now(), dur = 1600;
    const dec = (el.dataset.count.split('.')[1] || '').length;
    const fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    const step = (t) => {
      const k = Math.min(1, Math.max(0, (t - t0) / dur)), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt.format(dec ? to * e : Math.round(to * e));
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    if (e.target.classList.contains('diagram') || e.target.hasAttribute('data-nr-go')) e.target.classList.add('go');
    e.target.querySelectorAll('[data-count]').forEach(countUp);
    if (e.target.matches('[data-count]')) countUp(e.target);
    io.unobserve(e.target);
  }), { threshold: 0.15 }) : null;
  NR.observe = (root) => (root || document).querySelectorAll('.nr .rv, .nr [data-nr-count], .nr [data-nr-go]').forEach((el) => {
    if (io) io.observe(el); else el.classList.add('in');
  });

  /* ---------- twinkling stars ---------- */
  NR.stars = (root) => (root || document).querySelectorAll('[data-nr-stars]').forEach((box) => {
    if (box.childElementCount) return;
    const n = +box.dataset.nrStars || 46;
    for (let i = 0; i < n; i++) {
      const s = document.createElement('i');
      s.style.left = Math.random() * 100 + '%';
      s.style.top = Math.random() * 100 + '%';
      s.style.animationDelay = Math.random() * 4 + 's';
      box.appendChild(s);
    }
  });

  /* ---------- bag ---------- */
  NR.setBag = (count) => document.querySelectorAll('[data-nr-bag-count]').forEach((n) => {
    n.textContent = count;
    n.classList.add('pop');
    setTimeout(() => n.classList.remove('pop'), 300);
  });
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Adds items, refreshes Dawn's cart drawer contents (without opening it) and the bag count. */
  /* Appstle's product-page script rewrites selling_plan on cart adds for this product from its own widget's checked
     radio; our pages don't render that widget, so keep a hidden one in step with the shopper's choice. */
  const appstleShim = (items) => {
    let w = document.getElementById('NrAppstleShim');
    if (!w) {
      w = document.createElement('div'); w.id = 'NrAppstleShim'; w.className = 'appstle_sub_widget'; w.hidden = true;
      w.innerHTML = '<input type="radio" name="selling_plan" value="" tabindex="-1" aria-hidden="true">';
      document.body.appendChild(w);
    }
    const r = w.querySelector('input'), sub = items.find((i) => i.selling_plan);
    r.value = sub ? sub.selling_plan : ''; r.checked = !!sub;
  };

  NR.add = (items) => (appstleShim(items), fetch(root() + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items, sections: 'cart-drawer' }),
  }).then((r) => { if (!r.ok) throw r; return r.json(); })
    .then((res) => {
      const drawer = document.querySelector('cart-drawer');
      const html = res.sections && res.sections['cart-drawer'];
      if (drawer && html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
        const cur = drawer.querySelector('#CartDrawer');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        drawer.classList.remove('is-empty');
      }
      return fetch(root() + 'cart.js');
    })
    .then((r) => r.json())
    .then((cart) => { NR.setBag(cart.item_count); document.dispatchEvent(new CustomEvent('nr:cart', { detail: cart })); return cart; }));

  /* Buttons with data-nr-add="variantId" add one unit and flash a confirmation. */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-nr-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    const label = b.innerHTML;
    b.disabled = true;
    NR.add([{ id: +b.dataset.nrAdd, quantity: 1 }])
      .then(() => { b.classList.add('added'); b.textContent = b.dataset.addedLabel || '✓'; })
      .catch(() => { b.textContent = b.dataset.errorLabel || '!'; })
      .finally(() => setTimeout(() => { b.classList.remove('added'); b.innerHTML = label; b.disabled = false; }, 1400));
  });

  /* ---------- header: mega menu + mobile menu ---------- */
  NR.header = (root) => {
    const nav = root.querySelector('.nr.nav');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = '1';
    const btns = nav.querySelectorAll('.menu button[data-m]');
    let closeT;
    const openMega = (id) => btns.forEach((b) => {
      const on = b.dataset.m === id;
      b.setAttribute('aria-expanded', on);
      const panel = document.getElementById(b.dataset.m);
      if (panel) panel.classList.toggle('open', on);
    });
    btns.forEach((b) => {
      b.addEventListener('mouseenter', () => { clearTimeout(closeT); openMega(b.dataset.m); });
      b.addEventListener('click', () => openMega(b.getAttribute('aria-expanded') === 'true' ? null : b.dataset.m));
    });
    nav.querySelectorAll('.mega').forEach((m) => {
      m.addEventListener('mouseenter', () => clearTimeout(closeT));
      m.addEventListener('mouseleave', () => { closeT = setTimeout(() => openMega(null), 200); });
    });
    const menu = nav.querySelector('.menu');
    if (menu) menu.addEventListener('mouseleave', () => { closeT = setTimeout(() => openMega(null), 250); });

    const burger = nav.querySelector('.burger');
    const mm = root.querySelector('.mmenu');
    const setMobile = (on) => {
      if (!burger || !mm) return;
      burger.setAttribute('aria-expanded', on);
      mm.classList.toggle('open', on);
      document.body.style.overflow = on ? 'hidden' : '';
    };
    if (burger) burger.addEventListener('click', () => setMobile(burger.getAttribute('aria-expanded') !== 'true'));
    if (mm) mm.addEventListener('click', (e) => { if (e.target.closest('a')) setMobile(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { openMega(null); setMobile(false); } });
    document.addEventListener('click', (e) => { if (!e.target.closest('.menu,.mega')) openMega(null); });

    root.querySelectorAll('[data-nr-loc]').forEach((s) => s.addEventListener('change', () => s.form.submit()));
    NR.slider(root);
  };

  /* Country slider: slide the pill, then submit Shopify's localization form. */
  NR.slider = (root) => (root || document).querySelectorAll('[data-nr-mkt]:not(.ready)').forEach((g) => {
    const pill = g.querySelector('.nr-mkt-pill'), btns = [...g.querySelectorAll('button')];
    const place = (b) => { pill.style.width = b.offsetWidth + 'px'; pill.style.transform = `translateX(${b.offsetLeft - 4}px)`; };
    const cur = btns.find((b) => b.classList.contains('on')) || btns[0];
    if (!cur) return;
    g.classList.add('ready'); place(cur);
    window.addEventListener('resize', () => place(btns.find((b) => b.classList.contains('on')) || cur));
    const choose = (b) => {
      if (b.classList.contains('on')) return;
      btns.forEach((x) => { const on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); x.tabIndex = on ? 0 : -1; });
      place(b); b.focus();
      const f = g.closest('form'), fd = new FormData(f);
      fd.set('country_code', b.value);
      const go = () => fetch(f.action, { method: 'POST', body: fd })
        .then((r) => { window.location.href = r.url || window.location.href; })
        .catch(() => { const h = document.createElement('input'); h.type = 'hidden'; h.name = 'country_code'; h.value = b.value; f.appendChild(h); f.submit(); });
      setTimeout(go, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 360);
    };
    btns.forEach((b, i) => {
      b.addEventListener('click', (e) => { e.preventDefault(); choose(b); });
      b.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault(); const n = btns[(i + (e.key === 'ArrowRight' ? 1 : -1) + btns.length) % btns.length]; choose(n);
      });
    });
  });

  const init = (root) => { NR.observe(root); NR.stars(root); NR.header(root || document); NR.slider(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  NR.init = init;
})();
